<template>
    <v-col cols="6" md="3">
        
        <v-card
            class="mx-auto"
            tile
        >
            <v-list rounded>
            <v-subheader>In {{ type }}s</v-subheader>
            <v-list-item-group
                color="primary"
                v-if="groups.length > 0"
            >   
           
                <v-list-item
                v-for="(item, i) in groups"
                :key="i"
                >
                
                <v-list-item-icon>
                    <v-icon>mdi-eye</v-icon>
                </v-list-item-icon>
         
                <v-list-item-content>
                    <router-link :to="{ name: type + '-gallery' , params: { id: item.name.toLowerCase() }}"><v-list-item-title v-text="item.name"></v-list-item-title></router-link>
                </v-list-item-content>
    
                </v-list-item>
            </v-list-item-group>
            <v-list-item-group v-else>
                <v-list-item>
                <v-list-item-icon>
                    <v-icon>mdi-eye-off</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                     None or Hidden
                </v-list-item-content>
            </v-list-item>
            </v-list-item-group>
            </v-list>

        </v-card>

        </v-col>
</template>

<script>
export default {
    name: "GroupItem",
    props: ['groups','type','private']
}
</script>
